// extracted by mini-css-extract-plugin
export default {"Plantel":"plantel_Plantel__3flKq","player":"plantel_player__ht1CN","cornerRB":"plantel_cornerRB__r0GNx","cornerLT":"plantel_cornerLT__pX0kQ"};